import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import BlacklistsGridLayout from './containers/Grid';

export default function BlacklistLayout() {
  return <Router>
    <PrivateRoute path="/settings/blacklist" component={BlacklistsGridLayout} />
  </Router>
}
